(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-header')) {
    customElements.define('new-header', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.new-header__toggle');
        this.menu = this.querySelector('.new-header__menu');

        // The theme scrolls .page-wrapper on desktop and the document on mobile
        this.onScroll = () => {
          const wrapper = document.querySelector('.page-wrapper');
          const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
          this.classList.toggle('is-scrolled', y > 8);
        };
        this.onDocumentClick = (e) => { if (!this.contains(e.target)) this.setMenu(false); };
        this.onKeydown = (e) => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) {
            this.setMenu(false);
            this.toggle.focus();
          }
        };
        this.onBreakpoint = () => this.setMenu(false);
        this.mobile = window.matchMedia('(max-width: 749px)');

        this.toggle.addEventListener('click', () => this.setMenu(!this.classList.contains('is-open')));
        this.menu.addEventListener('click', () => this.setMenu(false));
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        this.mobile.addEventListener('change', this.onBreakpoint);
        this.onScroll();

        // Keep "Cart (2)" in step with the theme's cart drawer
        this.onCartUpdate = (event) => {
          if (!event.promise) return;
          event.promise.then(({ cart, detail }) => {
            const count = (cart && cart.totalQuantity) || (detail && detail.itemCount) || 0;
            this.querySelectorAll('[data-new-cart-count]').forEach((el) => {
              el.textContent = count > 0 ? ` (${count})` : '';
            });
          }).catch(() => {});
        };
        import('@shopify/events').then(({ StandardEvents }) => {
          this.cartEvent = StandardEvents.cartLinesUpdate;
          document.addEventListener(this.cartEvent, this.onCartUpdate);
        }).catch(() => {});
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        this.mobile.removeEventListener('change', this.onBreakpoint);
        if (this.cartEvent) document.removeEventListener(this.cartEvent, this.onCartUpdate);
      }

      setMenu(open) {
        this.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', open);
        this.toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-hero')) {
    customElements.define('new-hero', class extends HTMLElement {
      connectedCallback() {
        this.media = this.querySelector('img.new-hero__media');
        if (!this.media || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        let ticking = false;
        // The theme scrolls .page-wrapper on desktop and the document on mobile
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const wrapper = document.querySelector('.page-wrapper');
            const y = Math.min(Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0), window.innerHeight);
            this.media.style.transform = `translate3d(0, ${(y * 0.03).toFixed(1)}px, 0)`;
            ticking = false;
          });
        };
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      }

      disconnectedCallback() {
        if (this.onScroll) document.removeEventListener('scroll', this.onScroll, { capture: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-product-main')) {
    customElements.define('new-product-main', class extends HTMLElement {
      connectedCallback() {
        this.setupGallery();
        this.form = this.querySelector('[data-new-pm-form]');
        if (!this.form) return;
        this.status = this.form.querySelector('[data-status]');
        this.addButton = this.form.querySelector('[data-add]');
        this.setupQuantity();
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }

      setupGallery() {
        const main = this.querySelector('.new-pm__main');
        const thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        if (!thumbs.length) return;

        let current = 0;
        const show = (i) => {
          current = (i + thumbs.length) % thumbs.length;
          const thumb = thumbs[current];
          main.removeAttribute('srcset');
          main.src = thumb.dataset.full;
          main.alt = thumb.dataset.alt;
          thumbs.forEach((t, n) => t.setAttribute('aria-current', n === current));
          const strip = thumb.parentElement;
          strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
        };
        thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
        this.querySelector('[data-gallery-prev]').addEventListener('click', () => show(current - 1));
        this.querySelector('[data-gallery-next]').addEventListener('click', () => show(current + 1));
      }

      setupQuantity() {
        const value = this.form.querySelector('[data-qty-value]');
        const input = this.form.querySelector('[data-qty-input]');
        const set = (n) => {
          const qty = Math.min(99, Math.max(1, n));
          value.textContent = qty;
          input.value = qty;
        };
        this.form.querySelector('[data-qty-minus]').addEventListener('click', () => set(Number(input.value) - 1));
        this.form.querySelector('[data-qty-plus]').addEventListener('click', () => set(Number(input.value) + 1));
      }

      // Same flow as the theme's product-form.js, so the cart drawer and "Cart (2)" both update.
      // If this fails to start, the form posts normally and the customer lands on the cart page.
      async onSubmit(event) {
        event.preventDefault();
        if (this.addButton.getAttribute('aria-busy') === 'true') return;

        let CartLinesUpdateEvent;
        try {
          ({ CartLinesUpdateEvent } = await import('@shopify/events'));
        } catch {
          this.form.submit();
          return;
        }

        const body = new FormData(this.form);
        const quantity = Number(body.get('quantity')) || 1;
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        if (sectionIds.length) body.append('sections', sectionIds.join(','));

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: body.get('id'), quantity }],
          promise: deferred.promise,
        }));

        this.addButton.setAttribute('aria-busy', 'true');
        this.showStatus('');

        const fetchCart = () => fetch(`${this.dataset.cartUrl}.json`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const resolveWith = (ajaxCart, detail) => deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: {
            items: ajaxCart.items,
            source: 'product-form-component',
            sourceId: this.id,
            itemCount: quantity,
            productId: this.dataset.productId,
            ...detail,
          },
        });

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
            body,
          }).then((r) => r.json());
          const ajaxCart = await fetchCart();

          if (response.status) {
            resolveWith(ajaxCart, { didError: true });
            this.showStatus(response.description || response.message, true);
          } else {
            resolveWith(ajaxCart, { didError: false, sections: response.sections });
            this.showStatus('Added to your cart.');
          }
        } catch (error) {
          deferred.reject(error);
          this.showStatus('Could not add to cart. Please try again.', true);
        } finally {
          this.addButton.removeAttribute('aria-busy');
        }
      }

      showStatus(message, isError = false) {
        this.status.textContent = message;
        this.status.classList.toggle('new-pm__status--error', isError);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-story-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-story')) {
    customElements.define('new-story', class extends HTMLElement {
      connectedCallback() {
        const play = this.querySelector('.new-story__play');
        const dialog = this.querySelector('.new-story__dialog');
        if (!play || !dialog) return;

        const stage = dialog.querySelector('.new-story__stage');
        const template = dialog.querySelector('template');

        play.addEventListener('click', () => {
          stage.replaceChildren(template.content.cloneNode(true));
          dialog.showModal();
        });
        dialog.querySelector('.new-story__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => stage.replaceChildren());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
